// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__Q3sD7","footer":"ModalInfo_footer__1YFGU"};